module.exports = __webpack_public_path__ + "media/images/svg/chat-13abe4209ca381924af83a7d126ac154.svg";